import React from 'react'

import styles from './buttonMediumPrimary.module.scss'

const ButtonMediumPrimary = props => {
  const { handleClick, title } = props

  return (
    <button className={styles.buttonMediumPrimary} onClick={handleClick}>
      {!!props.children ? <span className={styles.wrapp}>{props.children}</span> : title}
    </button>
  )
}

export default React.memo(ButtonMediumPrimary)